import { render, staticRenderFns } from "./InboxLatestChart.vue?vue&type=template&id=63f028a8"
import script from "./InboxLatestChart.vue?vue&type=script&lang=js"
export * from "./InboxLatestChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports